'use client'

import { useTranslations } from 'next-intl'
import { CSSProperties } from 'react'
import { Button } from '@/components/button'
import { SvgMapNeedle } from '@/icons/svg-map-needle'
import { cn } from '@/utils/styles/cn'

interface IMapPlaceholderProps {
    onActivate: () => void
    className?: string
    style?: CSSProperties
}

export const MapPlaceholder = ({ onActivate, className, style }: IMapPlaceholderProps) => {
    const t = useTranslations()

    return (
        <div
            className={cn(
                'relative flex items-center justify-center overflow-hidden bg-gray-100',
                className
            )}
            style={style}
        >
            <div className="flex max-w-sm flex-col items-center gap-3 px-6 py-8 text-center">
                <SvgMapNeedle color="none" size={40} />

                <p className="text-lg font-bold">{t('consent.map.title')}</p>

                <p className="text-sm text-gray-600">{t('consent.map.description')}</p>

                <Button styleType="primary" shape="pill" onClick={onActivate}>
                    {t('consent.map.button')}
                </Button>
            </div>
        </div>
    )
}
